/**
 * Onarım Açılış Formu (Opening Form) için çeviri objesi hazırlar.
 */
export const getOpeningPdfTranslations = (t) => ({
    title: t('warranty.customerDeclaration.pdf.title'),
    documentNo: t('warranty.customerDeclaration.pdf.documentNo'),
    date: t('warranty.customerDeclaration.pdf.date'),
    vehicleOwner: t('warranty.customerDeclaration.pdf.vehicleOwner'),
    phone: t('warranty.customerDeclaration.pdf.phone'),
    licensePlate: t('warranty.customerDeclaration.pdf.licensePlate'),
    chassisNo: t('warranty.customerDeclaration.pdf.chassisNo'),
    brand: t('warranty.customerDeclaration.pdf.brand'),
    model: t('warranty.customerDeclaration.pdf.model'),
    km: t('warranty.customerDeclaration.pdf.km'),
    trafficDate: t('warranty.customerDeclaration.pdf.trafficDate'),
    vehicleAcceptDate: t('warranty.customerDeclaration.pdf.vehicleAcceptDate'),
    receivedBy: t('warranty.customerDeclaration.pdf.deliveredBy'),
    deliveredBy: t('warranty.customerDeclaration.pdf.receivedBy'),
    customerStatement: t('warranty.customerDeclaration.pdf.customerStatement'),
    title2: t('warranty.customerDeclaration.pdf.title2'),
    signature: t('warranty.customerDeclaration.pdf.signature'),
    authorizedSignature: t('warranty.customerDeclaration.pdf.authorizedSignature'),
    status: t('warranty.customerDeclaration.pdf.status'),
    statusOpen: t('warranty.customerDeclaration.pdf.statusOpen'),
    statusClosed: t('warranty.customerDeclaration.pdf.statusClosed'),
});

/**
 * Onarım Kapanış Formu (Closing Form) için çeviri objesi hazırlar.
 */
export const getClosingPdfTranslations = (t) => ({
    title: t('warranty.customerDeclaration.pdf.closingTitle') || 'Onarım Kapanış Formu',
    repairNo: t('warranty.customerDeclaration.pdf.repairNo') || 'ONARIM NO',
    repairDate: t('warranty.customerDeclaration.pdf.repairDate') || 'TARİH',
    repairTime: t('warranty.customerDeclaration.pdf.repairTime') || 'SAAT',
    licensePlate: t('warranty.customerDeclaration.pdf.licensePlate') || 'PLAKA',
    km: t('warranty.customerDeclaration.pdf.km') || 'KM',
    arrivalReason: t('warranty.customerDeclaration.pdf.arrivalReason') || 'GELİŞ NEDENİ',
    invoiceDate: t('warranty.customerDeclaration.pdf.invoiceDate') || 'FATURA TARİHİ',
    invoiceNo: t('warranty.customerDeclaration.pdf.invoiceNo') || 'FATURA NO',
    chassisNo: t('warranty.customerDeclaration.pdf.chassisNo') || 'ŞASİ NO',
    vehicleType: t('warranty.customerDeclaration.pdf.vehicleType') || 'TİPİ',
    labor: t('warranty.customerDeclaration.pdf.labor') || 'İŞÇİLİK',
    sparePart: t('warranty.customerDeclaration.pdf.sparePart') || 'YEDEK PARÇA',
    otherCost: t('warranty.customerDeclaration.pdf.otherCost') || 'DİĞER MALİYET',
    total: t('warranty.customerDeclaration.pdf.total') || 'TOPLAM',
    approvedBy: t('warranty.customerDeclaration.pdf.approvedBy') || 'ONAY VEREN',
    deliveredBy: t('warranty.customerDeclaration.pdf.willReceive') || 'Aracı Teslim Eden',
    willReceive: t('warranty.customerDeclaration.pdf.deliveredBy') || 'Aracı Teslim Alacak',
    deliveryPhone: t('warranty.customerDeclaration.pdf.deliveryPhone') || 'Telefon',
    customerComplaints: t('warranty.customerDeclaration.pdf.customerComplaints') || 'Müşteri İtirazları',
    serviceNotes: t('warranty.customerDeclaration.pdf.serviceNotes') || 'Servis Açıklamaları',
    closingNotes: t('warranty.customerDeclaration.pdf.closingNotes') || 'Kapanış Notları',
    orderNo: t('warranty.customerDeclaration.pdf.orderNo') || 'O.T.',
    partLabor: t('warranty.customerDeclaration.pdf.partLabor') || 'Parça/İşçilik',
    partNo: t('warranty.customerDeclaration.pdf.partNo') || 'Parça/İşçilik No',
    description: t('warranty.customerDeclaration.pdf.description') || 'Açıklama',
    quantity: t('warranty.customerDeclaration.pdf.quantity') || 'İlk.Süre',
    unitPrice: t('warranty.customerDeclaration.pdf.unitPrice') || 'B.Fiyat',
    amount: t('warranty.customerDeclaration.pdf.amount') || 'Tutar',
    discount: t('warranty.customerDeclaration.pdf.discount') || 'İnd%',
    netTotal: t('warranty.customerDeclaration.pdf.netTotal') || 'Net T.',
    closingTotal: t('warranty.customerDeclaration.pdf.closingTotal') || 'Kapanış Toplam Tutar',
    discountTotal: t('warranty.customerDeclaration.pdf.discountTotal') || 'İndirim Tutarı',
    discountedTotal: t('warranty.customerDeclaration.pdf.discountedTotal') || 'İndirimli Toplam',
    kdvTotal: t('warranty.customerDeclaration.pdf.kdvTotal') || 'K.D.V Tutarı',
    invoiceTotal: t('warranty.customerDeclaration.pdf.invoiceTotal') || 'Fatura Toplamı',
    reportDate: t('warranty.customerDeclaration.pdf.reportDate') || 'Rapor Tarihi',
    reportTime: t('warranty.customerDeclaration.pdf.reportTime') || 'Rapor Saati',
    reportCode: t('warranty.customerDeclaration.pdf.reportCode') || 'Rapor Kodu',
    reportReceiver: t('warranty.customerDeclaration.pdf.reportReceiver') || 'Raporu Alan',
    karsanWarranty: t('warrantyClaims.detail.costSummary.karsanGuaranteed') || 'Karsan Garantili',
    customerPays: t('warrantyClaims.detail.costSummary.customerPay') || 'Müşteri Öder',
    serviceWarranty: t('warrantyClaims.detail.costSummary.serviceGuaranteed') || 'Servis Garantili',
    warrantyType: t('warranty.customerDeclaration.pdf.warrantyType') || 'Tip',
    failureSolution: t('warranty.customerDeclaration.pdf.failureSolution') || 'Arıza Çözümü',
    laborDiscountRate: t('warranty.customerDeclaration.pdf.laborDiscountRate') || 'İŞÇ. İSK.%',
    partsDiscountRate: t('warranty.customerDeclaration.pdf.partsDiscountRate') || 'PRÇ. İSK.%'
});

/**
 * Kapanış formu için API'den gelen veriyi PDF formatına hazırlar.
 */
export const mapClosingFormData = (result) => ({
    id: result.onarimNo,
    repairNo: result.onarimNo,
    repairDate: result.createdDate,
    customerStatement: result.customerStatement,
    serviceNote: result.serviceNote || '',
    licensePlate: result.licensePlate,
    chassisNo: result.chassisNo,
    kmInformation: result.kmInformation,
    customerNameSurname: result.adSoyad,
    fullName: result.fullName,
    deliveredBy: result.receivingDeliveryPerson,
    deliveryPhone: result.deliveryPhone,
    receivedBy: result.receivingPerson,
    customerPhone: result.customerPhone,
    warrClaimsNo: result.warrClaimsNo,
    estimatedPart: result.totalItemPrice,
    estimatedLabor: result.totalLaborPrice,
    estimatedOtherCost: result.totalOtherCostPrice || 0,
    estimatedTotal: (result.totalItemPrice || 0) + (result.totalLaborPrice || 0) + (result.totalOtherCostPrice || 0),
    acceptedItemPrice: result.totalItemAcceptedPrice,
    acceptedLaborPrice: result.totalLaborAcceptedPrice,
    acceptedOtherCost: result.totalOtherCostPrice || 0,
    details: result.details || [],
    totalPrice: result.totalPrice || 0,
    totalDiscountedPrice: result.totalDiscountedPrice || 0,
    isDomestic: result.isDomestic ?? true,
    closingNotes: result.closingNotes || '',
    failureSolution: result.failureSolution || '',
    partsDiscountRate: result.partsDiscountRate ?? null,
    laborDiscountRate: result.laborDiscountRate ?? null
});
